import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import CardNotificationBase from './CardNotificationBase'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

const CardNotificationPelaksanaanAppealApprovedPS = (
  cardProps: CardNotificationBaseProps
) => {
  return (
    <CardNotificationBase {...cardProps}>
      <div className="mt-6">
        <Link
          href={`${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja`}
          passHref
        >
          <Button as="a" color="blue" size="sm" className="!w-[130px]">
            Cek dokumen
          </Button>
        </Link>
      </div>
    </CardNotificationBase>
  )
}

export default CardNotificationPelaksanaanAppealApprovedPS
